// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3IZz_","info":"PatientInfo_info__1j48O"};